import React from 'react';
import { CONFIG } from 'config/config';
import { isMobile } from 'react-device-detect';
import { View } from '@coinscrap/webapp-core';
import { ProgressBar } from 'components/ProgressBar/ProgressBar/ProgressBar';
import { SectionSubTitle } from 'components/SectionSubTitle/SectionSubTitle';
import { SectionTitle } from 'components/SectionTitle/SectionTitle';
import BackNextButton from '../../../components/BackNextButton/BackNextButton';
import { DashedLines } from '../../../components/DashedLines/DashedLines';
import { downloadDoc } from '../../../helpers/downloadDoc';
import * as S from './styles';

export const Wrapper = ({
	children,
	width = CONFIG.components.mainWrapper.width,
	style,
	showTopSection,
	showStepBar = true,
	step,
	title,
	subtitle,
	tooltip,
	isAgent,
	enlaceResumePdf = undefined,
}) => {
	return (
		<S.Wrapper wrapperWidth={width} style={style} isAgent={isAgent}>
			{showTopSection && (
				<>
					{showStepBar && <ProgressBar step={step} />}
					<View rowSt={!isMobile} justifyBetweenSt>
						<View columnSt wInitialSt>
							<SectionTitle title={title} tooltip={tooltip} />
							{subtitle && <SectionSubTitle title={subtitle} tooltip={tooltip} />}
						</View>
						{enlaceResumePdf && (
							<BackNextButton
								wrapperWidth="initial"
								marginTop={isMobile ? 10 : 0}
								marginBottom={0}
								isBackShown={false}
								nextText={'Descargar presupuesto'}
								onClickNext={() =>
									downloadDoc(enlaceResumePdf, 'Estudio de Seguro')
								}
								hasIcon={false}
								fontFamily={CONFIG.fonts.regular}
							/>
						)}
					</View>
					<DashedLines />
				</>
			)}
			{!showTopSection && title && (
				<>
					<SectionTitle title={title} tooltip={tooltip} />
					{subtitle && <SectionSubTitle title={subtitle} tooltip={tooltip} />}
					<DashedLines />
				</>
			)}
			{children}
		</S.Wrapper>
	);
};
